import { Component, Vue } from 'vue-property-decorator';
import SettingService from '@/modules/services/setting.service';

const settingService = new SettingService();

@Component
export default class Session extends Vue {
  public SessionData: [] = [];

  existUser :any ='';

  public created() {
    $(document).prop('title', 'Dshop Session')
    const currentUser: any = JSON.parse(localStorage.getItem('user'));
    this.existUser = currentUser.user_id;
    this.getSessions();
  }

  private getSessions() {
    this.SessionData = [];
    this.$store.state.Loading = true;
    settingService.getSessions().then((res: any) => {
      this.$store.state.Loading = false;
      if (res.data.status === true) {
        this.SessionData = res.data.data;
      }
    }, (err: any) => {
      this.$store.state.Loading = false;
      this.$store.dispatch('showErrorMsg', err.message);
    })
  }

  private deleteSessionById(id) {
    this.$store.state.Loading = true;
    const request = { token: id };
    settingService.deleteSessionById({ data: request}).then((res: any) => {
      this.$store.state.Loading = false;
      const response = res.data.data;
      if (response.status) {
        this.$store.dispatch('showSuccessMsg', response.message);
        this.getSessions();
      }
    }, (err: any) => {
      this.$store.state.Loading = false;
      this.$store.dispatch('showErrorMsg', err.message);
    })
  }

  private deleteAllSessions() {
    this.$store.state.Loading = true;
    settingService.deleteAllSessions().then((res: any) => {
      this.$store.state.Loading = false;
      const response = res.data.data;
      if (response.status) {
        this.$store.dispatch('showSuccessMsg', response.message);
        this.getSessions();
      }
    }, (err: any) => {
      this.$store.state.Loading = false;
      this.$store.dispatch('showErrorMsg', err.message);
    })
  }

}
